// extracted by mini-css-extract-plugin
export default {"menuButton":"MenuButton_menuButton__uG0My","icon":"MenuButton_icon__i8c1I","text":"MenuButton_text__Rzjhr","arrowIcon":"MenuButton_arrowIcon__Cicii"};